import {
  FETCH_CATEGORY_PRODUCTS_FAILURE,
  FETCH_CATEGORY_PRODUCTS_SUCCESS,
  FETCH_CATEGORY_PRODUCTS_REQUEST,
} from "../actions/categoryActions";

const initialState = {
  loading: false,
  products: [],
  error: null,
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORY_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CATEGORY_PRODUCTS_SUCCESS:
      // console.log("FETCH_CATEGORY_PRODUCTS_SUCCESS:", JSON.stringify(action.payload, null, 2));

      return {
        ...state,
        loading: false,
        products:
          Array.isArray(action.payload) && action.payload.length > 0
            ? action.payload
            : [],
        error: null,
      };
    case FETCH_CATEGORY_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        products: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default productReducer;
